import _ from "lodash";
import { apiFetcher } from "./apiFetcher";

export const mobilizeiPushNotificationsService = {
    getAllPushNotifications,
    getPushNotificationById,
    sendPushNotification,
    cancelPushNotification,
    deletePushNotification,
    editPushNotification
};

function getAllPushNotifications(platformId, storeId, page = 0) {
    const url = `platforms/${platformId}/stores/${storeId}/push_notifications?page=${page}`

    return apiFetcher(url, { method: "GET" }, false, true).then(response => ({
        notifications: response.data,
        totalCount: _.toInteger(response.headers.get('x-total-count')) || 0
    }));
}

function getPushNotificationById(platformId, storeId, id) {
    const url = `platforms/${platformId}/stores/${storeId}/push_notifications/${id}`

    return apiFetcher(url, { method: "GET" }, false).then(response => response);
}

function sendPushNotification(platformId, storeId, data) {
    const url = `platforms/${platformId}/stores/${storeId}/push_notifications`

    return apiFetcher(url, {
        method: "POST",
        body: JSON.stringify(data)
    }).then(response => response);
}

function editPushNotification(platformId, storeId, id, data) {
    const url = `platforms/${platformId}/stores/${storeId}/push_notifications/${id}`
    
    return apiFetcher(url, {
        method: "PUT",
        body: JSON.stringify(data)
    }).then(response => response);
}

function cancelPushNotification(platformId, storeId, id) {
    const url = `platforms/${platformId}/stores/${storeId}/push_notifications/${id}/cancel`

    return apiFetcher(url, { method: "POST" }).then(response => response);
}

function deletePushNotification(platformId, storeId, id) {
    const url = `platforms/${platformId}/stores/${storeId}/push_notifications/${id}`

    return apiFetcher(url, { method: "DELETE" }, false).then(response => response);
}
